import { render, staticRenderFns } from "./KeywordOffState.vue?vue&type=template&id=4b3f7004&scoped=true"
import script from "./KeywordOffState.vue?vue&type=script&lang=js"
export * from "./KeywordOffState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3f7004",
  null
  
)

export default component.exports